import type { InteractionsState } from './types';

export const initialInteractionsState: InteractionsState = {
  saving: false,
  success: false,
  error: false,
  retries: 0,
  maxRetries: 3
};
